import React, { useEffect, useState } from 'react';
import CustomVariantCalculator from './CustomVariantCalculator';
import CustomVariantSummary from './CustomVariantSummary';
import BuyButton from '../BuyButton';
import { translate } from '../../Services/translation';
import { post } from '../../Services/http';
import { addConfiguration } from '../../Services/Cart.service';
import { useDispatch } from 'react-redux';
import { receive as cartRecive } from '../../Actions/Cart.action';

const CustomVariantCalculatorContainer = ({
  maxWidth,
  minWidth,
  pricePerUnit,
  campaignPricePerUnit,
  articleNumber,
  configuratorType,
  unitOfMeasurement,
  currencySymbol,
  panelOptions,
  bulkPrice,
  bulkInfoLength,
  isBuyableChannel,
  storesUrl,
  isB2b,
}) => {
  const isFixedWidth =
    configuratorType === 'SquareMeterFixedWidth' ||
    configuratorType === 'MeterFixedWidth';
  const [width, setWidth] = useState(isFixedWidth ? maxWidth : '');
  const [length, setLength] = useState('');
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [configuratorModel, setConfiguratorModel] = useState({});
  const [comment, setComment] = useState('');

  const dispatch = useDispatch();
  const addObjectsToCart = async (cartObjects) => {
    try {
      const cart = await addConfiguration(cartObjects);
      dispatch(cartRecive(cart));
    } catch (err) {
      console.log(err);
    }
  };

  const addToCartClick = () => {
    const cartObject = [
      {
        articleNumber: configuratorModel.articleNumber,
        note: comment == '' ? null : comment,
        configurationData: {
          length: configuratorModel.length,
          width: configuratorModel.width,
          additionalOptions:
            configuratorModel.priceResult.optionDetails?.map(
              (option) => option.displayName
            ) ?? [],
        },

        quantity: configuratorModel.priceResult.calculatedUnits,
        splitRows: true,
      },
      ...configuratorModel.priceResult.optionDetails?.map(
        (option) =>
          ({
            articleNumber: option.articleNumber,
            quantity: option.quantity,
            splitRows: true,
          } ?? [])
      ),
    ];
    addObjectsToCart(cartObject);
    clearFields();
    setConfiguratorModel({});
  };
  const onCalculateClick = () => {
    post('/api/productconfigurator/calculateprice', {
      width,
      length,
      articleNumber,
      selectedOptions,
    })
      .then((res) => res.json())
      .then((data) => setConfiguratorModel(data))
      .catch((err) => console.log('error', err));
  };
  const onOptionChanged = (articleId, checked) => {
    setSelectedOptions((selectedOptions) => {
      if (checked) {
        return [...selectedOptions, articleId];
      } else {
        const index = selectedOptions.indexOf(articleId);
        const selectedOptionsCopy = [...selectedOptions];
        if (index > -1) {
          selectedOptionsCopy.splice(index, 1);
        }
        return selectedOptionsCopy;
      }
    });
  };
  const clearFields = () => {
    setWidth(isFixedWidth ? maxWidth : '');
    setLength('');
    setConfiguratorModel({});
    setSelectedOptions([]);
    setConfiguratorModel({});
  };
  return (
    <div>
      <div className="[ custom-variant__description ] [ text-medium lh-2 ]">
        {translate(`product-page.${configuratorType}.description`)} (
        {maxWidth && maxWidth}cm) (
        {campaignPricePerUnit ? (
          <>
            <span className="text-linethrough">
              {pricePerUnit + currencySymbol}/
              {unitOfMeasurement == 'm2' ? 'm²' : unitOfMeasurement}
            </span>
            <span className="color-error-700">
              {' '}
              {campaignPricePerUnit} {currencySymbol}/
              {unitOfMeasurement == 'm2' ? 'm²' : unitOfMeasurement}
            </span>
            {')'}
          </>
        ) : (
          <span>
            {pricePerUnit} {currencySymbol}/
            {unitOfMeasurement == 'm2' ? 'm²' : unitOfMeasurement}
            {')'}
          </span>
        )}
      </div>
      {bulkInfoLength && (
        <div className="[ custom-variant__description--bulk ] [ text-medium lh-2 ]">
          {translate('product-page.bulk-info')}
          <div>
            {translate('product-page.price-from')} {bulkInfoLength}
            {unitOfMeasurement} -{' '}
            <span className="bold">
              ({Math.floor(parseFloat(bulkPrice) / parseFloat(bulkInfoLength))}
              {currencySymbol}/
              {unitOfMeasurement == 'm2' ? 'm²' : unitOfMeasurement})
            </span>
          </div>
        </div>
      )}
      <CustomVariantCalculator
        width={width}
        setWidth={setWidth}
        length={length}
        setLength={setLength}
        minWidth={minWidth}
        maxWidth={maxWidth}
        onCalculateClick={onCalculateClick}
        configuratorType={configuratorType}
        panelOptions={panelOptions}
        currencySymbol={currencySymbol}
        onOptionChanged={onOptionChanged}
        selectedOptions={selectedOptions}
        isFixedWidth={isFixedWidth}
      />
      {configuratorModel.priceResult && (
        <CustomVariantSummary
          configuratorModel={configuratorModel}
          currencySymbol={currencySymbol}
        />
      )}
      {isB2b && (
        <div className="custom-variant__comments">
          <span className="[ text-medium bold lh-2 ]">
            {translate('custom-variant.comments-title')}
          </span>
          <div className="styled-textarea-input">
            <textarea
              placeholder=" "
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
            <label>{translate('custom-variant.comments-title')}</label>
          </div>
        </div>
      )}
      <div className="custom-variant__buy-button-container">
        <span className="custom-variant__buy-info [ text-small lh-1 ] ">
          {translate('custom-variant.extra-buy-info')}
        </span>
        {isBuyableChannel ? (
          <div
            onClick={() => addToCartClick()}
            className={`buy-button ${
              !configuratorModel.priceResult && 'buy-button--disabled'
            }`}
          >
            {configuratorModel.priceResult
              ? translate('product-page.buy-button')
              : translate('product-page.pick-a-size')}
          </div>
        ) : (
          <a className="buy-button" href={storesUrl}>
            {translate('product-page.find-your-store')}
          </a>
        )}
        <div
          className="custom-variant__clear-fields"
          onClick={() => clearFields()}
        >
          {translate('custom-variant.clear-values')}
        </div>
      </div>
    </div>
  );
};

export default CustomVariantCalculatorContainer;
